import React from 'react';
import useMaps from '../../hooks/location/useMaps';
import useCompanyLocation from '../../hooks/location/useCompanyLocation';
import { Moment } from 'moment';
import AddressHelpers from '../../services/helpers/AddressHelpers';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';

interface Props {
  datetime?: null | string | Moment;
  showPhoneNumber?: boolean;
  shouldOpenMap?: boolean;
  className?: string;
}

export default function CompanyDescription(props: Props) {
  const { company } = useSelector((state: StoreInterface) => state.initialData);

  const { datetime, showPhoneNumber, shouldOpenMap, className } = props;

  const { openMap } = useMaps();
  const location = useCompanyLocation(datetime);

  return (
    <div className={className}>
      <p className="text-sm">{company?.name}</p>
      <div>
        <button onClick={() => (shouldOpenMap ? openMap() : null)}>
          <p className="text-gray-700 underline mt-xs text-sm">
            {AddressHelpers.format({
              street_name: location?.address,
              city: location?.city,
              country: location?.country,
              zip_code: location.zip_code,
            })}
          </p>
        </button>
      </div>
      {showPhoneNumber && company?.phone_number && (
        <div className="mt-xs">
          <a href={`tel:${company?.phone_number}`} className="inline text-blue-100 text-sm">
            <p>Tel: {company?.phone_number}</p>
          </a>
        </div>
      )}
    </div>
  );
}
